import React from 'react';
import { TextField } from '@material-ui/core';
import AddressFields from './AddressFields';
import LocationTypeFields from './LocationTypeFields';
import { Fieldset, WelcomeNote } from './blocks';

const WELCOME =
    'Welcome to the warehouse & store location settings page! When you created your account, you set up your basic ' +
    'profile and billing information. This tab is where you can register your first warehouse or store location. You ' +
    'do not have any locations set up in our system yet, but all you have to do fill in the fields below and click save.';

/**
 * Registration form for a client's very first location. Deliberately a narrower form than the
 * per-location one — no contact details, code, or WMS flags — and its City and Zip are filled by
 * the address autocomplete only, which is why they are locked here but editable when editing.
 */
const FirstLocationForm = ({ state, callbacks }) => {
    const { chosen, hasError, viewOnly } = state;
    const { patch } = callbacks;

    return (
        <>
            <WelcomeNote>{WELCOME}</WelcomeNote>

            <Fieldset columns={2}>
                <TextField
                    fullWidth
                    variant="outlined"
                    id="first-location-name"
                    label="First Location Name"
                    value={chosen.location_name || ''}
                    error={hasError.location_name}
                    disabled={viewOnly}
                    InputLabelProps={{ shrink: !!chosen.location_name }}
                    onChange={(e) => patch({ location_name: e.target.value })}
                />
            </Fieldset>

            <AddressFields
                chosen={chosen}
                hasError={hasError}
                viewOnly={viewOnly}
                cityLocked
                zipLocked
                onAddressUpdate={callbacks.updateAddress}
                patch={patch}
            />

            <LocationTypeFields chosen={chosen} hasError={hasError} viewOnly={viewOnly} patch={patch} />
        </>
    );
};

export default FirstLocationForm;
